import { render } from "./Button.vue?vue&type=template&id=33cac74f&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=33cac74f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33cac74f"

export default script